interface IntroSectionProps {
  title: string;
  paragraphs: string[];
  imageUrl: string;
}

export default function IntroSection({ title, paragraphs, imageUrl }: IntroSectionProps) {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[400px] md:h-[500px] overflow-hidden rounded-none">
            <img
              src={imageUrl}
              alt="Brickell Miami high-rise impact windows"
              className="w-full h-full object-cover"
              onError={(e) => {
                (e.target as HTMLImageElement).style.backgroundColor = "#064e3b";
              }}
            />
          </div>
          <div>
            <h2 className="text-[#064e3b] text-3xl md:text-4xl font-black mb-8">
              {title}
            </h2>
            <div className="space-y-5">
              {paragraphs.map((para, i) => (
                <p key={i} className="text-[#444444] text-base leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}